import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { TwinListResponse, TwinQueryParams } from '@frontend/slot/types';

export class TwinClient extends APIClient {
    public static readonly endpoint = '/slot-api/v1';

    public static async fetchTwins(queryParams?: ApiQueryParams<TwinQueryParams>): Promise<TwinListResponse> {
        return await this.apiPaginated<TwinListResponse, TwinQueryParams>(`${this.endpoint}/twins`, queryParams);
    }
}
